import { render } from "./CampaignItem.vue?vue&type=template&id=7e972f5a&scoped=true"
import script from "./CampaignItem.vue?vue&type=script&lang=js"
export * from "./CampaignItem.vue?vue&type=script&lang=js"

import "./CampaignItem.vue?vue&type=style&index=0&id=7e972f5a&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e972f5a"]])

export default __exports__